import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import useInputRef from './useInputRef';
import api from '../components/GoogleMaps';
import Typography from '@material-ui/core/Typography';
import StyledText from './StyledTextInput';
import LookupButton from '../components/LookupButton';

var GoogleAddress = function GoogleAddress(props) {
  var apiKey = props.apiKey,
      address = props.address,
      active = props.active,
      fieldId = props.fieldId;
  var onChange = props.onChange,
      onFocus = props.onFocus,
      onBlur = props.onBlur;
  var description = props.description,
      readonly = props.readonly,
      error = props.error,
      variant = props.variant;
  var lookupVisiblity = props.lookupVisiblity,
      xpath = props.xpath;

  var _useInputRef = useInputRef(active),
      _useInputRef2 = _slicedToArray(_useInputRef, 2),
      inputRef = _useInputRef2[0],
      refNode = _useInputRef2[1];

  var googleApi = api.useGoogleAPI(apiKey);

  var onAddressChange = function onAddressChange(event) {
    var value = event.target.value;
    onChange && onChange(value);
  };

  React.useEffect(function () {
    if (!refNode || googleApi.loading) return;
    if (!apiKey) return;
    var autocomplete = new googleApi.google.maps.places.Autocomplete(refNode);
    autocomplete.addListener('place_changed', function () {
      var place = autocomplete.getPlace();
      if (!place.geometry) return onAddressChange({
        target: {
          value: place.name
        }
      });
      var address = '';

      if (place.address_components) {
        address = [place.address_components[0] && place.address_components[0].short_name || '', place.address_components[1] && place.address_components[1].short_name || '', place.address_components[2] && place.address_components[2].short_name || ''].join(' ');
      }

      onAddressChange({
        target: {
          value: address || place.name
        }
      });
    });
    var userAgent = navigator.userAgent.toLowerCase();
    var isSafari = userAgent.indexOf('safari') != -1 && userAgent.indexOf('chrome') == -1;

    if (isSafari) {
      setTimeout(function () {
        var container = document.getElementsByClassName('pac-container')[0];
        container.addEventListener('touchend', function (e) {
          e.stopImmediatePropagation();
        });
      }, 500);
    }
  }, [refNode, googleApi]);
  var hasError = !!error;
  var showLookupButton = xpath && lookupVisiblity !== 'hide';
  var InputProps = {
    endAdornment: showLookupButton ? React.createElement(LookupButton, {
      fieldId: fieldId
    }) : null
  };
  return React.createElement(StyledText, {
    InputProps: InputProps,
    helperText: error || description || React.createElement(Typography, null, " "),
    value: address,
    variant: variant,
    error: hasError,
    disabled: readonly || googleApi.loading,
    placeholder: googleApi.loading ? 'Loading Google API...' : 'Enter a location',
    inputRef: inputRef,
    onBlur: onBlur,
    onFocus: onFocus,
    onChange: onAddressChange
  });
};

export default React.memo(GoogleAddress);